module.exports = __webpack_public_path__ + "img/6.686a7840.png";